import { useImpersonation } from "@/lib/impersonation";
import { Icons } from "@/components/Icons";
import { alertDialog } from "@/lib/dialog";

/**
 * Persistent banner pinned above the main shell whenever a super admin
 * is acting on someone else's behalf. We deliberately make this loud:
 * a wrong toggle in this state can cause real damage so the user
 * should be unable to forget they're impersonating.
 */
export function ImpersonationBanner() {
  const imp = useImpersonation();
  if (!imp.isImpersonating || !imp.target) return null;

  return (
    <div
      role="alert"
      style={{
        background: "var(--terracotta)",
        color: "#fff",
        padding: "8px 16px",
        display: "flex",
        alignItems: "center",
        gap: 12,
        fontSize: 13,
        position: "sticky",
        top: 0,
        zIndex: 1000,
        borderBottom: "1px solid rgba(0,0,0,0.15)",
      }}>
      <Icons.AlertTri size={16} />
      <div style={{ flex: 1, lineHeight: 1.4 }}>
        <strong>Impersonating</strong> {imp.target.name} ({imp.target.email})
        {imp.adminEmail && (
          <span style={{ opacity: 0.85 }}> — as {imp.adminEmail}</span>
        )}
      </div>
      <button
        className="btn btn-sm"
        onClick={() => { imp.stop().catch((e: Error) => void alertDialog(e.message)); }}
        style={{
          background: "rgba(255,255,255,0.18)",
          color: "#fff",
          border: "1px solid rgba(255,255,255,0.35)",
        }}>
        Stop impersonating
      </button>
    </div>
  );
}
